import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { string } from 'prop-types'
import { ALL } from '../utils/constants'
import Doodle from '../components/doodle/Doodle'
import SearchBar from '../components/SearchBar'

const ScreensHome = ({ site }) => {
  const [query, handleSearchInput] = useState('')
  const [toResults, onSearch] = useState(false)
  const pathname = site === 'us' ? `/${ALL}` : `${site}/${ALL}`

  return (
    toResults === true
      ? <Redirect
        push
        to={{
          pathname: pathname,
          search: '?q=' + query
        }}
      />
      : <div
        className='
        afd-container-main
        afd-container-main--margin-top
        afd-container-main--margin-bottom
        nft-container-main-search
        clearfix
        afd-mobile-margin'
      >
        <Doodle site={site} />
        <SearchBar
          query={query}
          handleInput={({ target }) => handleSearchInput(target.value)}
          onSearch={() => onSearch(true)}
        />
      </div>

  )
}

ScreensHome.propTypes = {
  site: string
}

export default ScreensHome